
import SvgIcon from '@/components/SvgIcon.vue';
import { CropVariety } from '@/store/models/block';
import { BlockStore } from '@/store/modules';
import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
    SvgIcon
  }
})
export default class CropVarietyList extends Vue {
  get cropVarieties() {
    return BlockStore.CropVarieties;
  }

  logTab = 'stdout';

  loading = false;

  tableColumn = [
    {
      name: 'id',
      label: 'Id',
      field: (row: CropVariety) => row.id,
      sortable: true,
      align: 'left',
      style: 'width: 10px',
      headerStyle: 'width: 10px;'
    },
    {
      name: 'crop_type',
      label: 'Crop Type',
      field: (row: CropVariety) => row.cropTypeName,
      sortable: true,
      align: 'left'
    },
    {
      name: 'name',
      label: 'Name',
      field: (row: CropVariety) => row.name,
      sortable: true,
      align: 'left'
    },
    {
      name: 'actions',
      label: 'Actions',
      align: 'right'
    }
  ];
  initialPagination: {
    sortBy: string;
    descending: boolean;
    page: number;
    rowsPerPage: number;
  } = {
    sortBy: 'id',
    descending: true,
    page: 1,
    rowsPerPage: 10
  };

  async created() {
    this.loading = true;
    await BlockStore.getAllCropVarieties();
    this.loading = false;
  }
}
